<div class="row" *ngIf="showCity(day)">
  <div class="col-12 pl-4 pt-2">
    <span class="overview-icons">
      <app-service-icon [icon]="'globe-africa'" [customPath]="getServiceIconPath('globe-africa')"></app-service-icon>
    </span>
    <span class="text-capitalize">{{ day?.city_name | lowercase }}</span>
  </div>
</div>
